// src/components/onboarding/OnboardingLayout.js
import React from 'react';
import { ProgressBar, PrimaryButton } from './OnboardingUI';

const OnboardingLayout = ({
  children,
  currentStep,
  totalSteps,
  showProgress = true,
  canProceed,
  onNext,
  loading,
  buttonText = "Continuer",
  error
}) => {
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-gray-800/30 rounded-3xl border border-white/10 shadow-2xl shadow-black/50">
        <div className="h-[min(700px,calc(100vh-2rem))] p-6 flex flex-col">
          {showProgress && <ProgressBar current={currentStep} total={totalSteps} />}

          <div className="flex-1 flex flex-col min-h-0 overflow-y-auto onboarding-scroll pr-1">
            {children}
          </div>

          {error && (
            <p className="text-red-400 text-sm text-center mb-4">{error}</p>
          )}

          <div className="pt-4 flex-shrink-0">
            <PrimaryButton
              onClick={onNext}
              disabled={!canProceed}
              loading={loading}
            >
              {buttonText}
            </PrimaryButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingLayout;
